/*
 * ============================================================
 *  Madera Nueva — Gift Guard
 * ============================================================
 *  Mantiene los regalos GRATIS del carrito sincronizados con la
 *  cantidad del producto principal (MaderaUltra Spray Restaurador).
 *
 *  - Cada regalo tiene su propio umbral de cantidad.
 *  - Bidireccional: quita el regalo si ya no corresponde y lo
 *    vuelve a agregar si el cliente sube la cantidad.
 *  - NO modifica el archivo del tema (main.js está ofuscado).
 *    Actúa por encima usando la AJAX Cart API + Section Rendering.
 *  - Seguridad: SOLO toca líneas cuya variante es un regalo
 *    conocido Y cuyo precio es $0. Nunca toca algo que el cliente pagó.
 *  - Kill-switch: localStorage.MN_GIFT_DISABLE = '1' lo desactiva.
 *
 *  Si cambian los productos/umbrales, editar CONFIG abajo.
 * ============================================================
 */
(function () {
  'use strict';

  // Kill-switch de diagnóstico: localStorage.MN_GIFT_DISABLE='1' desactiva el guard.
  try { if (window.localStorage && localStorage.getItem('MN_GIFT_DISABLE') === '1') return; } catch (e) {}

  // Evitar doble inclusión (p. ej. si el tag se duplica en el layout).
  if (window.__MN_GIFT_GUARD__) return;
  window.__MN_GIFT_GUARD__ = true;

  var CONFIG = {
    // Producto principal (MaderaUltra). Se suma la cantidad de TODAS sus variantes.
    mainProductId: 9700032119009,

    // Regalos: variante ($0, oculta) + cantidad mínima del producto principal para tenerlo.
    gifts: [
      { variant: 49029479465185, threshold: 1, name: 'Guia Madera Ultra' },
      { variant: 49029479760097, threshold: 2, name: 'Pano Microfibra' },
      { variant: 49029479235809, threshold: 3, name: 'Gift Card $500' }
    ],

    debounceMs: 250,
    maxAddFailures: 2 // tras N fallos agregando un regalo (p.ej. agotado), dejar de intentar
  };

  var DEBUG = false; // poner window.__MN_GIFT_DEBUG = true en consola para ver logs
  var origFetch = window.fetch.bind(window);
  var busy = false;           // true mientras corren NUESTRAS propias llamadas
  var pendingWhileBusy = false; // hubo cambios del carrito mientras estábamos ocupados
  var forceRefresh = false;   // un render viejo del tema pudo pisar nuestra UI: re-dibujar
  var scheduled = null;
  var addFailures = {};       // variant -> cantidad de fallos al agregar
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

  function log() {
    if (DEBUG || window.__MN_GIFT_DEBUG) {
      try { console.log.apply(console, ['[gift-guard]'].concat([].slice.call(arguments))); } catch (e) {}
    }
  }

  function getCart() {
    return origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js HTTP ' + r.status);
        return r.json();
      });
  }

  function mainQtyFromCart(cart) {
    return (cart.items || []).reduce(function (sum, it) {
      return it.product_id === CONFIG.mainProductId ? sum + it.quantity : sum;
    }, 0);
  }

  // Calcula qué regalos hay que agregar (1) o quitar (0). Solo devuelve diferencias.
  function computeUpdates(cart) {
    var mainQty = mainQtyFromCart(cart);
    var removals = {};
    var additions = {};
    CONFIG.gifts.forEach(function (g) {
      // Línea de regalo presente: misma variante Y precio 0 (jamás tocar algo pago).
      var line = (cart.items || []).filter(function (it) {
        return it.variant_id === g.variant && it.price === 0;
      })[0];
      var currentQty = line ? line.quantity : 0;
      var desiredQty = mainQty >= g.threshold ? 1 : 0;
      if (currentQty === desiredQty) return;
      if (desiredQty === 0) {
        removals[g.variant] = 0;
      } else if ((addFailures[g.variant] || 0) < CONFIG.maxAddFailures) {
        additions[g.variant] = desiredQty;
      }
    });
    return { removals: removals, additions: additions, mainQty: mainQty };
  }

  function postUpdate(updates) {
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      if (!r.ok) throw new Error('update.js HTTP ' + r.status);
      return r.json();
    });
  }

  function sectionsToRequest() {
    var list = [];
    if (document.getElementById('CartDrawer')) list.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) list.push('cart-icon-bubble');
    if (document.getElementById('main-cart-items')) list.push('main-cart-items');
    if (document.getElementById('main-cart-footer')) list.push('main-cart-footer');
    return list;
  }

  function replaceInner(doc, targetSel, sourceSel) {
    var target = document.querySelector(targetSel);
    var source = doc.querySelector(sourceSel || targetSel);
    if (target && source) target.innerHTML = source.innerHTML;
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (html == null) return;
      var doc;
      try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return; }
      if (id === 'cart-drawer') replaceInner(doc, '#CartDrawer');
      else if (id === 'cart-icon-bubble') replaceInner(doc, '#cart-icon-bubble');
      else if (id === 'main-cart-items') replaceInner(doc, '#main-cart-items .js-contents');
      else if (id === 'main-cart-footer') replaceInner(doc, '#main-cart-footer');
    });
  }

  // Refresca la vista con el estado REAL del carrito usando un update.js no-op
  // con Section Rendering (un GET ?sections= devuelve el JSON del producto, no sirve).
  function refreshUI() {
    var sections = sectionsToRequest();
    if (!sections.length) return Promise.resolve();
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: {},
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('sections HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) { renderSections(data.sections); })
      .catch(function (e) { log('error refreshUI', e); });
  }

  // Aplica remociones (críticas) y adiciones (con fallback individual), luego refresca la UI.
  function applyUpdates(removals, additions) {
    var removalKeys = Object.keys(removals);
    var additionKeys = Object.keys(additions);
    var chain = Promise.resolve();

    // 1) Remociones primero: nunca deben quedar bloqueadas por una adición fallida.
    if (removalKeys.length) {
      chain = chain.then(function () {
        return postUpdate(removals).catch(function (e) { log('error removals', e); });
      });
    }

    // 2) Adiciones: en lote; si el lote falla (p.ej. regalo agotado), una por una.
    if (additionKeys.length) {
      chain = chain.then(function () {
        return postUpdate(additions).catch(function () {
          var seq = Promise.resolve();
          additionKeys.forEach(function (variant) {
            seq = seq.then(function () {
              var single = {};
              single[variant] = additions[variant];
              return postUpdate(single).catch(function (e) {
                addFailures[variant] = (addFailures[variant] || 0) + 1;
                log('fallo agregando variante ' + variant + ' (intento ' + addFailures[variant] + ')', e);
              });
            });
          });
          return seq;
        });
      });
    }

    // 3) Refrescar la vista y avisar.
    return chain
      .then(function () { return refreshUI(); })
      .then(function () {
        try { document.dispatchEvent(new CustomEvent('mn:gifts-updated')); } catch (e) {}
      });
  }

  function reconcile() {
    if (busy) { pendingWhileBusy = true; return Promise.resolve(); }
    busy = true;
    var didUpdate = false;
    return getCart()
      .then(function (cart) {
        var res = computeUpdates(cart);
        var nRem = Object.keys(res.removals).length;
        var nAdd = Object.keys(res.additions).length;
        if (!nRem && !nAdd) {
          log('sin cambios (mainQty=' + res.mainQty + ')');
          // El carrito está bien, pero un render viejo del tema pudo dejar la vista desactualizada.
          if (forceRefresh) { forceRefresh = false; return refreshUI(); }
          return;
        }
        log('mainQty=' + res.mainQty, 'removals', res.removals, 'additions', res.additions);
        didUpdate = true;
        forceRefresh = false;
        return applyUpdates(res.removals, res.additions);
      })
      .catch(function (e) { log('error reconcile', e); })
      .then(function () {
        busy = false;
        // Si el carrito cambió mientras trabajábamos, volver a verificar.
        if (pendingWhileBusy) {
          pendingWhileBusy = false;
          // Si nosotros tocamos el carrito, el render del tema que se cruzó puede ser viejo.
          if (didUpdate) forceRefresh = true;
          scheduleReconcile();
        }
      });
  }

  var timerPending = false;
  function scheduleReconcile() {
    if (busy) { pendingWhileBusy = true; return; }
    clearTimeout(scheduled);
    timerPending = true;
    scheduled = setTimeout(function () { timerPending = false; reconcile(); }, CONFIG.debounceMs);
  }

  // ¿Hay una sincronización pendiente o en curso?
  function isDirty() { return timerPending || busy || pendingWhileBusy; }

  // ---- Checkout: si hay una sincronización pendiente, terminarla ANTES de ir al checkout ----
  // El checkout es un POST nativo del formulario del carrito (no pasa por fetch/XHR).
  // Con tope duro de 1.5s: el checkout NUNCA se bloquea, pase lo que pase.
  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      if (form.dataset && form.dataset.mnFlushed === '1') return;
      var action = (form.getAttribute('action') || '').split('?')[0];
      if (!/\/cart\/?$/.test(action)) return;
      var sub = e.submitter;
      var isCheckout = sub ? sub.name === 'checkout' : !!form.querySelector('[name="checkout"]');
      if (!isCheckout || !isDirty()) return;
      e.preventDefault();
      clearTimeout(scheduled);
      timerPending = false;
      var done = false;
      var go = function () {
        if (done) return;
        done = true;
        try { form.dataset.mnFlushed = '1'; } catch (err) {}
        try {
          if (sub && typeof sub.click === 'function') { sub.click(); return; }
        } catch (err) {}
        try {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = 'checkout'; i.value = '';
          form.appendChild(i);
          form.submit();
        } catch (err) {}
      };
      setTimeout(go, 1500); // tope duro: jamás demorar el checkout más de esto
      reconcile().then(go, go);
    } catch (err) { /* ante cualquier error: no interferir con el checkout */ }
  }, true);

  // ---- Interceptar mutaciones del carrito (las nuestras usan origFetch y no pasan por acá) ----
  window.fetch = function (input, init) {
    var url = '';
    try { url = (typeof input === 'string') ? input : (input && input.url) || ''; } catch (e) {}
    var isCart = CART_RE.test(url);
    var p = origFetch.apply(this, arguments);
    if (isCart) { p.then(function () { scheduleReconcile(); }).catch(function () {}); }
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { this.__mnCart = CART_RE.test(url || ''); } catch (e) {}
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__mnCart) {
      this.addEventListener('loadend', function () { scheduleReconcile(); });
    }
    return _send.apply(this, arguments);
  };

  // ---- Arranque: reconciliar por si el carrito ya trae regalos que no corresponden ----
  function init() { reconcile(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Expuesto por si se quiere forzar manualmente
  window.__MN_reconcileGifts = reconcile;
})();
